import { Promise, Products, services, dataServices } from '@ambita/ambita-components-core';
import { ProductWithProductFee } from '../typings/LandRegistryLookup';

const PRODUCT_WE_PANTEBOK = 'WE11123100';
const STATUS_ACTIVE = 'ACTIVE';

let productCache: Products.Product;
const util = services.util;
const xhr = dataServices.xhr;
const config = dataServices.config;
const log = services.log;

const mandatoryProductsRequestOptions = {
  municipality: '0000',
  producttype: 'MANDATORY',
  salesclient: 'NYEINFOLAND'
};

function getMandatoryProducts(params): Promise<Products.ApiProducts> {
  const url = `${config.getConfig().PRODUCT_LIST_ADDRESS}?${util.encodeUriQuery(params)}`;
  return xhr.getJSON(url);
}

function reduceProductFee(previousValue, mandatoryProduct: Products.Product) {
  return previousValue + mandatoryProduct.price.salesPriceVat;
}

function addProductFeeToProduct(product: ProductWithProductFee): Promise<ProductWithProductFee> {
  const options = util.assign({}, mandatoryProductsRequestOptions, { suppliercode: product.supplier.code });
  return getMandatoryProducts(options).then((mandatoryProducts: Products.ApiProducts) => {
    product.price.productFee = mandatoryProducts.products.reduce(reduceProductFee, 0);
    return product;
  }).catch(error => {
    const productError = 'Error fetching product fee from Product API';
    log.error(productError, error);
    return Promise.reject(error);
  });
}

function returnProductCache(): Promise<ProductWithProductFee> {
  return Promise.resolve<ProductWithProductFee>(util.clone(productCache));
}

let fetchingPantebokProduct: Promise<ProductWithProductFee>;

export function getPantebokProduct(): Promise<Products.Product> {
  if (fetchingPantebokProduct) {
    return fetchingPantebokProduct.then(() => {
      return returnProductCache();
    }).catch((error) => {
      return Promise.reject(error);
    });
  }

  return fetchingPantebokProduct = new Promise<ProductWithProductFee>((resolve, reject) => {
    getSingleProduct(PRODUCT_WE_PANTEBOK)
      .then((pantebokProduct: ProductWithProductFee) => {
        if (pantebokProduct && pantebokProduct.status && pantebokProduct.status.code !== STATUS_ACTIVE) {
          const PRODUCT_NOT_ACTIVE = `Product ${pantebokProduct.code} is not active`;
          throw new Error(PRODUCT_NOT_ACTIVE);
        } else {
          return addProductFeeToProduct(pantebokProduct);
        }
      })
      .then((pantebokProduct: ProductWithProductFee) => {
        productCache = pantebokProduct;
        resolve(util.clone(pantebokProduct));
      })
      .catch((error) => {
        const productError = 'Error fetching product from Product API';
        log.error(productError, error);
        reject(error);
      });
  });
}

function getSingleProduct(productCode: string): Promise<Products.ApiSingleProduct> {
  const url = `${config.getConfig().PRODUCT_LIST_ADDRESS}/${productCode}`;
  return xhr.getJSON(url);
}

export function confirmPantebokProductOrder(orderCollectionData) {
  return xhr.post(config.getConfig().SHOPPING_ORDERCOLLECTION_ADDRESS, {
    data: orderCollectionData
  }).catch((error) => {
    return Promise.reject(error);
  });
}
